export const SET_CASH_RECEIPT = "SET_CASH_RECEIPT";
export const SET_SPECIFIC_CASH_RECEIPT = "SET_SPECIFIC_CASH_RECEIPT";
export const RESET_SPECIFIC_SALES = "RESET_SPECIFIC_SALES";
export const SET_BALANCE = "SET_BALANCE";
export const SET_PENDING_SALES = "SET_PENDING_SALES";
